import { Superheader } from "./styles";
import { TitleView } from "components/styles";
import { StyledHeader } from "views/Recursos/styles";
import UniversitySpaceFilters from "../UniversitySpaceFilters";
import Header from "../UniversitySpaceFilters/Header";
import { RESOURCE_MODULE_TITLES } from "views/Recursos/utils/constants";

const UniversitySpaceHeader = ({
    isCampusCoordinator, loadingRequest,
    data, filters,
    allFilterFieldsWereFilled,
    paginator, resetUI
}) => {
    return (
        <StyledHeader>
            <Superheader>
                <TitleView>{RESOURCE_MODULE_TITLES.UNIVERSITY_SPACES}</TitleView>
            </Superheader>
            <UniversitySpaceFilters
                loadingRequest={loadingRequest}
                isCampusCoordinator={isCampusCoordinator}
                filters={filters}
                header={
                    <Header
                        appliedFilters={filters.appliedFilters}
                        paginator={paginator} />}
                resetUI={resetUI}
                data={data}
                allFilterFieldsWereFilled={allFilterFieldsWereFilled}/>
        </StyledHeader>
    );
}

export default UniversitySpaceHeader;